import { render } from "./PrivacyPolicy.vue?vue&type=template&id=40289778"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/joshpotterton.com/joshpotterton.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__